<div class="question-scale">
  <lib-question-hint 
    [hint]="'SLIDES.select_correct_answer' | translate">
  </lib-question-hint>

  <lib-scale-widget 
    class="animate__animated"
    [ngClass]="data.animation"
    [options]="data.answers"
    [questionHash]="questionHash"
    [(ngModel)]="answer"
    (ngModelChange)="onChange($event)"
    [style.animationDelay.ms]="data.animationDelay">
  </lib-scale-widget>
</div>